const translations = {
  'specialOffers.seo.title': 'Ofertas especiales en nuestros cursos TEFL en Barcelona y Sevilla',
  'specialOffers.seo.description':
    'Obtén más información sobre nuestros descuentos en cursos TEFL y ofertas especiales en nuestros cursos Trinity CertTESOL en Barcelona y Sevilla.',
  'specialOffers.sec1.title': 'Ofertas Especiales',
  'specialOffers.sec1.description':
    'En TEFL Iberia ofrecemos una amplia variedad de cursos para adaptarnos a todas las necesidades y presupuestos.  Aquí te presentamos algunas ofertas especiales en nuestros paquetes más populares:',
  'specialOffers.sec1.benL.title': 'Descuento Full Payment En Los Cursos Trinity CertTESOL:',
  'specialOffers.sec1.benR.title': 'Trae a un amigo',
  'specialOffers.sec1.benL.save': 'Ahorra ',
  'specialOffers.sec1.benR.discountEach': 'de descuento para cada uno',
  'specialOffers.sec1.benL.text1': 'Paga tu matrícula completa y ahorra 150€  ',
  'specialOffers.sec1.benL.text2':
    'Precio final, incluye curso, certificado y gastos de moderación.',
  'specialOffers.sec1.benL.text3':
    'Date la mejor educación para enseñar inglés como lengua extranjera.',
  'specialOffers.sec1.benR.text1': 'Descuento aplicable a los cursos Trinity CertTESOL.',
  'specialOffers.sec1.benR.text2': 'Estudia el mismo mes que tu amigo.',
  'specialOffers.sec1.benR.text3':
    'Combina la oferta con el descuento Early Bird para obtener un mayor descuento.',
};

export default translations;
